/**
 * Created by kaiyan2 on 2017/1/23.
 */
import React from 'react';
import axios from 'axios'
import { generateInfoCard, generateConfigData } from "Common/utility/infoCard";

import { getText } from "Common/utility/utils"


export default class LearningLabTrack extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      items: null
    }
  }


  componentDidMount() {
    if (this.props.config) {
      this.getTrackData(this.props.config);
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.config && this.props.config != prevProps.config) {
      this.getTrackData(this.props.config);
    }
  }


  getTrackData(config) {
    if (!config.querySelector("permalink")) {
      return
    }
    const permalink = config.querySelector("permalink").innerText.trim();

    if (!permalink) {
      return
    }

    const url = PubHub.APIHost + `/v1/foundation-search/catalogs/query?type=learninglab&code_name=${permalink}&contentSubtype=track`;

    axios.get(url).then((response) => {
      this.setState({
        permalink,
        items: response.data.items || []
      });
    });
  }

  renderData(items) {
    if (!items || !items.length) return null;
    const data = items[0];

    const moduleCount = data.modules.length;

    const labCount = data.modules.reduce((mPre, mCur) => {
      const labs = (mCur.submodules || []).reduce((smPre, smCur) => smPre + (smCur.items || []).length, 0);
      return mPre + labs;
    }, 0);

    const tags = data.tags.map((tag, index) => {
      const splitter = index != data.tags.length - 1 ? ',' : '';
      return <span key={tag} title={tag}
        target="_blank" className="pubhub-learning-lab-module-item-tag-link" data-track-name="learningLabModule:tag"
        data-track-value={tag}>{tag + splitter}</span>
    });

    const hours = ((data.meta.duration || 0) / 60).toFixed(1);

    const duration = data.meta.duration && (
      <div className="col">
        <div className="pubhub-learning-lab-track-item-col">
          <span className="pubhub-learning-lab-track-item-number">{hours}</span>
          <span className="pubhub-learning-lab-track-item-type">hours</span>
        </div>
      </div>
    )

    return <div className="pubhub-learning-lab-track-item">
      <div className="row ">
        <div className="col pubhub-learning-lab-track-item-title">
          <a href={"/learning/tracks/" + this.state.permalink}
            target="_blank" data-track-name="learningLabTrack:title"
            data-track-value={data.name}  rel="noopener noreferrer">{data.name}</a>
        </div>
      </div>
      <div className="row ">
        <div className="col pubhub-learning-lab-track-item-info">

          <div className="row pubhub-learning-lab-track-item-description">
            <div className="col">
              {data.description || data.contentFullText}
            </div>
          </div>

          <div className="row pubhub-learning-lab-track-item-tags">
            <div className="col">
              {tags}
            </div>
          </div>

          <div className="row pubhub-learning-lab-track-item-data">
            <div className="col ">
              <div className="pubhub-learning-lab-track-item-col">
                <span className="pubhub-learning-lab-track-item-number">{moduleCount}</span>
                <span className="pubhub-learning-lab-track-item-type">Modules</span>
              </div>
            </div>
            <div className="col">
              <div className="pubhub-learning-lab-module-item-col">
                <span className="pubhub-learning-lab-module-item-number">{labCount}</span>
                <span className="pubhub-learning-lab-module-item-type">Labs</span>
              </div>
            </div>
            {duration}
          </div>
        </div>
      </div>
    </div>
  }

  render() {
    const { config, location, type } = this.props;

    if (!config) {
      return <span className="pubhub-loading"></span>
    }

    const el_data = generateConfigData(config);

    const color = getText(config, "color");


    var items = <span className="pubhub-loading"></span>
    if (this.state.items) {
      items = this.renderData(this.state.items);
    }

    const typeClass = type ? "pubhub-learning-lab-track-" + type : "";

    const top_border = (() => {
      if (!type) {
        return null
      }


      const style = {
        background: color === "" ? null : color
      };

      return <div className="row pubhub-learning-lab-track-top-banner"
        style={style} />

    })();

    return (
      <div className={"pubhub-learning-lab-track " + typeClass}>
        <div className="container">
          <div className="row">
            <div className="col pubhub-learning-lab-track-title" style={{ "color": color + " !important" }}>
              {el_data.title}
            </div>
          </div>
          {top_border}
          {items}
        </div>
      </div>
    );
  }
}

